
import { defineComponent } from 'vue'
import { Chart } from 'highcharts-vue'
import { computed } from 'vue'

export default defineComponent({
  components: {
    highcharts: Chart,
  },
  props: {
    data: {
      required: true,
      type: Object as any,
    },
  },
  setup(props) {
    const chartOptionsData = computed(() => ({
      chart: {
        type: 'line',
      },
      title: {
        text: '',
      },
      yAxis: {
        title: {
          text: '',
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          lineWidth: 2,
          marker: {
            enabled: false,
            states: {
              hover: {
                enabled: false,
                lineWidth: 2,
              },
            },
          },
        },
      },
      xAxis: {
        categories: props.data.series,
        labels: {
          style: {
            color: '#4A4A4A',
          },
        },
      },
      series: [
        {
          data: props.data.categories,
        },
      ],
    }))

    return {
      chartOptionsData,
    }
  },
})
